import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const StarEmpty = (props) =>
	<svg width="1em" height="1em" viewBox="0 0 19 19" {...props}>
		<path d="M15.148 18.462a.494.494 0 01-.237-.061l-5.143-2.718L4.622 18.4a.509.509 0 01-.543-.04.521.521 0 01-.206-.506l.982-5.76-4.16-4.077a.51.51 0 01-.13-.53.517.517 0 01.415-.352l5.754-.841L9.31 1.056A.513.513 0 019.772.77a.52.52 0 01.463.287l2.571 5.239 5.754.84a.517.517 0 01.286.883l-4.16 4.077.98 5.76a.521.521 0 01-.518.607zM2.077 7.892l3.65 3.553c.123.118.18.293.151.46l-.863 5.018 4.514-2.37a.511.511 0 01.484 0l4.51 2.37-.863-5.018a.518.518 0 01.15-.46l3.652-3.554-5.043-.732a.51.51 0 01-.39-.285L9.772 2.308 7.514 6.874a.516.516 0 01-.39.285l-5.047.732z" />
	</svg>;

StarEmpty.propTypes = {
	fill: PropTypes.string,
};

StarEmpty.defaultProps = {
	fill: getColor('gray'),
};

export default StarEmpty;
